export default __webpack_public_path__ + "e6108c92c569734836094b87b2a28686.png";